//import './thesaurus-term-tree.scss'

import { defineComponent } from 'vue'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import ThesaurusTermTreeModal from "./thesaurus-term-tree-modal"

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sThesaurusTermTreeModal: ThesaurusTermTreeModal,
    },
    props: {
        thesaurusIdentifier: {},
        startValue: { type: String },
        placeholder: {},
        readOnly: {},
    },
    template: require('./thesaurus-term-tree.html'),
    data() {
        return {
            // @ts-ignore
            startThesaurusTerm: null as ThesaurusTerm | null,
        }
    },
    mounted() {
        if(this.startValue) {
            this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                if(thesaurusTerm && thesaurusTerm.id) {
                    this.startThesaurusTerm = thesaurusTerm
                }
            })
        }
    },
    computed: {
        startThesaurusTermTitle(): string {
            if(this.startThesaurusTerm) {
                return this.getThesaurusTermTitle(this.startThesaurusTerm)
            }
            return ''
        },
    },
    methods: {
        getThesaurusTermTitle(thesaurusTerm: ThesaurusTerm) {
            return getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), this.getAppLocale())
        },
        openModal() {
            if(!this.readOnly) {
                (this.$refs.modal as InstanceType<typeof ThesaurusTermTreeModal>).openModal()
            }
        },
    },
    watch: {
        startValue() {
            if(this.startValue) {
                this.$thesaurusTermDataStore.fetchOne(this.startValue).subscribe(thesaurusTerm => {
                    if(thesaurusTerm && thesaurusTerm.id) {
                        this.startThesaurusTerm = thesaurusTerm
                    }
                })
            } else {
                this.startThesaurusTerm = null
            }
        },
    },
})
